<template>
  <el-table
    :data="partsData"
    :row-class-name="tableRowClassName">
    <el-table-column label="名称" prop="name">
    </el-table-column>
    <el-table-column label="位置" prop="position">
      <template scope="scope">
        <span>{{ scope.row.position | mPosition }}</span>
      </template>
    </el-table-column>
    <el-table-column label="类型" prop="type">
      <template scope="scope">
        <span>{{ scope.row.type | layout }}</span>
      </template>
    </el-table-column>
    <el-table-column label="表单" prop="module_id" width="200">
      <template scope="scope">
        <span>{{ modelsById[scope.row.model_id] }}</span>
      </template>
    </el-table-column>
    <el-table-column label="排序" prop="sort"></el-table-column>
    <el-table-column label="操作" width="150">
      <template scope="scope">
        <el-button type="text" size="small" @click="setCurPart(scope.row, scope.$index)">配置</el-button>
        <el-button type="text" size="small" @click="delPart(scope.$index)">删除</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
  import mobileConfig from 'config/mobileConfig'
  export default {
    props: {
      partsData: {
        type: Array
      },
      modelsById: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        curIndex: 0
      }
    },
    methods: {
      tableRowClassName(row, index) {
        if (index === this.curIndex) {
          return 'info-row'
        }
        return ''
      },
      // 设置当前配置行
      setCurPart(item, index) {
        this.$emit('setCurPart', item)
        this.curIndex = index
      },
      delPart(index) {
        // 删除当前激活的配置项
        if (this.curIndex === index) {
          this.$emit('setCurPart', null)
        }
        this.$emit('deletePart', index)
      }
    },
    mixins: [mobileConfig]
  }
</script>


// WEBPACK FOOTER //
// partsTable.vue?6c3e6a66